<template>
  <div class="page-sim" v-if="funcView.device_sim_list">
    <div class="chart-container">
      <div class="pie">
        <div class="chart-title">{{ $t('dms_sim.SIMka_zhuang_tai') }}</div>
        <div class="chart-pie" ref="pie"></div>
      </div>
      <div class="bar">
        <div class="chart-title">{{ $t('dms_sim.SIMka_ji_huo_qu_shi') }}</div>
        <!-- <search-input class="supplier-search" v-model="formSearch.supplierName" :placeholder="$t('page_sim_gong_ying_shang')" @fetch="onPageChange({ page: 1 })"></search-input> -->
        <custom-select class="supplier-search" :placeholder="$t('dms_sim.gong_ying_shang')" code="dms_sim_supplier_name" v-model="formSearch.supplierName" @change="onPageChange({ page: 1 })"></custom-select>
        <el-date-picker v-model="year" type="year" class="year-picker" :picker-options="pickerOptions" @change="yearChangeHandler"></el-date-picker>
        <div class="chart-bar" ref="bar"></div>
      </div>
    </div>
    <div class="list-container">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item v-if="funcView.sim_update_state">
            <el-button :disabled="!updateSimStateVisible" @click="showUpdateSimStateDialog">{{ funcView.sim_update_state }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.sim_import_state">
            <el-button @click="showSimStateDialog">{{ funcView.sim_import_state }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.sim_set_flow">
            <el-button :disabled="!selectedSim.length" @click="showUPdateNetworkFlowDialog">{{ funcView.sim_set_flow }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.sim_import_flow">
            <el-button @click="showSimFlowDialog">{{ funcView.sim_import_flow }}</el-button>
          </el-form-item>
          <el-form-item v-if="funcView.sim_export" style="float: right; margin-right: 0">
            <el-button class="table-set" style="vertical-align: top" @click="exportTable">
              <i class="icon icon-daochu"></i>
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right" :class="{ 'mr-0': !funcView.sim_export }">
            <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_sim.jshModemSNIMSIICCID')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="link"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onSearch" @clear="clearFilter('')">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_sim.zhsysj')">
            <custom-date-picker
              style="width: 100%"
              v-model="formSearch.lastUseTime"
              type="daterange"
              value-format="YYYY-MM-DD HH:mm:ss"
              :start-placeholder="$t('dms_sim.kai_shi_ri_qi')"
              :end-placeholder="$t('dms_sim.jie_shu_ri_qi')"
              :picker-options="beforeToday"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_sim.shu_ju_dao_qi_ri')">
            <custom-date-picker
              style="width: 100%"
              v-model="formSearch.simEndTime"
              type="daterange"
              value-format="YYYY-MM-DD HH:mm:ss"
              :start-placeholder="$t('dms_sim.kai_shi_ri_qi')"
              :end-placeholder="$t('dms_sim.jie_shu_ri_qi')"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_sim.suo_shu_zong_bu')">
            <el-input v-model="formSearch.hqName" :placeholder="$t('dms_sim.suo_shu_zong_bu')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_sim.SIMtao_can')">
            <el-input v-model="formSearch.ratePlan" :placeholder="$t('dms_sim.SIMtao_can')"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table :data="simList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['monthToDateDataUsage', 'action']" v-model="selectedSim" type="checkbox" height="100%">
          <template v-slot:monthToDateDataUsage="scope">{{ formatToMb(scope.row.monthToDateDataUsage) }}</template>
          <template v-slot:action="scope">
            <el-button v-if="funcView.sim_active && checkBtnAuth(scope.row, 'active')" type="text" size="mini" @click="onActive(scope.row)">{{ funcView.sim_active }}</el-button>
            <el-button v-if="funcView.sim_stop && checkBtnAuth(scope.row, 'stop')" type="text" size="mini" @click="onStop(scope.row)">{{ funcView.sim_stop }}</el-button>
            <!-- 现在不允许注销 -->
            <!-- <el-button
              v-if="funcView.sim_cancel && checkBtnAuth(scope.row, 'cancel')"
              type="text"
              size="mini"
              @click="onCancel(scope.row)"
            >{{ funcView.sim_cancel }}</el-button> -->
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div class="empty-bottom"></div>
    <!-- <add-sim-dialog
      v-if="addSimDialogVisible"
      @close="addSimDialogVisible = false"
      :model="addSimDialogModel"
      @success="addSimSuccess"
    ></add-sim-dialog> -->
    <!-- <import-sim-dialog
      v-if="importSimDialogVisible"
      @close="importSimDialogVisible = false"
      :model="importSimDialogModel"
      @success="importSimSuccess"
    ></import-sim-dialog> -->
    <update-sim-state-dialog
      v-if="updateSimStateDialogVisible"
      @close="updateSimStateDialogVisible = false"
      :model="updateSimStateDialogModel"
      @success="updateSimStateSuccess"
    ></update-sim-state-dialog>
    <import-sim-state-dialog
      v-if="importSimStateDialogVisible"
      @close="importSimStateDialogVisible = false"
      :model="importSimStateDialogModel"
      @success="onPageChange({ page: 1 })"
    ></import-sim-state-dialog>
    <update-sim-network-flow-dialog
      v-if="updateNetworkFlowDialogVisible"
      @close="updateNetworkFlowDialogVisible = false"
      :model="updateNetworkFlowDialogModel"
      @success="getTableList"
    ></update-sim-network-flow-dialog>
    <import-sim-network-flow-dialog
      v-if="importSimNetworkFlowDialogVisible"
      @close="importSimNetworkFlowDialogVisible = false"
      :model="importSimNetworkFlowDialogModel"
      @success="onPageChange({ page: 1 })"
    ></import-sim-network-flow-dialog>
  </div>
</template>

<script>
import G2 from 'G2';
import DataSet from '@antv/data-set';
import insertCss from 'insert-css';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
// import addSimDialog from './children/add_sim_dialog';
// import importSimDialog from './children/import_sim_dialog';
import updateSimStateDialog from './children/update_sim_state_dialog';
import importSimStateDialog from './children/import_sim_state_dialog';

import updateSimNetworkFlowDialog from './children/update_sim_network_flow_dialog';
import importSimNetworkFlowDialog from './children/import_sim_network_flow_dialog';

// 饼图自定义样式

insertCss(`
    .pie-guide-html {
        width: 100px;
        height: 80px;
        vertical-align: middle;
        text-align: center;
        line-height: 0.2;
    }

    .pie-guide-html .title {
        font-size: 12px;
        color: #8c8c8c;
        font-weight: 300;
    }

    .pie-guide-html .value {
        font-size: 12px;
        color: #000;
        font-weight: bold;
        padding-left: 10px;
    }
`);

export default {
  name: 'sim',
  mixins: [resetFormSearchMixins],
  components: {
    // addSimDialog,
    // importSimDialog,
    updateSimStateDialog,
    importSimStateDialog,
    updateSimNetworkFlowDialog,
    importSimNetworkFlowDialog,
  },
  data() {
    return {
      tableCode: 'sim_page',
      provide: true,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        search: '',
        supplierName: '',

        // 最后使用时间、数据到期日、所属总部      SIM套餐
        // lastUseTime  simEndTime  hqName      ratePlan
        lastUseTime: [],
        simEndTime: [],
        hqName: '',
        ratePlan: '',
      },
      simList: [],
      totalRows: null,
      pieData: {},
      year: new Date(),
      selectedSim: [],
      barData: [],
      pie: null,
      bar: null,
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      // addSimDialogVisible: false,
      // addSimDialogModel: {},
      // importSimDialogVisible: false,
      // importSimDialogModel: {},
      importSimStateDialogVisible: false,
      importSimStateDialogModel: {},
      importSimNetworkFlowDialogVisible: false,
      importSimNetworkFlowDialogModel: {},
      updateSimStateDialogVisible: false,
      updateSimStateDialogModel: {},
      updateNetworkFlowDialogVisible: false,
      updateNetworkFlowDialogModel: {},
      link: null,
    };
  },
  computed: {
    // 修改SIM状态按钮判断
    updateSimStateVisible() {
      const selectedSim = this.selectedSim;
      if (selectedSim && selectedSim.length && this.dicMap.sim_status) {
        const simStatus = this.dicMap.sim_status;

        const whiteList = [
          // 未激活
          `${simStatus.un_activated}`,
          // 已激活
          `${simStatus.activated}`,
          // 已停用
          `${simStatus.terminated}`,
          // 已失效
          `${simStatus.invalid}`,
        ];
        const noInWhiteList = selectedSim.some((item) => !whiteList.includes(`${item.simState}`));
        return !noInWhiteList;
      }

      return false;
    },
  },
  methods: {
    fixBarData(list) {
      // const yearPreFix = String(year);
      const monthArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      const ret = monthArr.map((month) => {
        const tmp = list.find((item) => item.month === month);
        if (tmp) {
          return {
            month: [month, this.$t('dms_sim.yue')].join(''),
            count: tmp.num,
          };
        } else {
          return {
            month: [month, this.$t('dms_sim.yue')].join(''),
            count: 0,
          };
        }
      });
      return ret;
    },
    // 导入SIM state
    showSimStateDialog() {
      this.importSimStateDialogModel = {
        title: this.$t('dms_sim.pldrSIMzt'),
      };
      this.importSimStateDialogVisible = true;
    },
    // 导入SIM 流量
    showSimFlowDialog() {
      this.importSimNetworkFlowDialogModel = {
        title: this.$t('dms_sim.pldrSIMll'),
      };
      this.importSimNetworkFlowDialogVisible = true;
    },
    showUpdateSimStateDialog() {
      this.updateSimStateDialogModel = {
        title: this.$t('dms_sim.xiu_gaiSIMzhuang_tai'),
        data: {
          selectedSim: this.selectedSim,
        },
      };
      this.updateSimStateDialogVisible = true;
    },
    showUPdateNetworkFlowDialog() {
      this.updateNetworkFlowDialogModel = {
        title: this.$t('dms_sim.xiu_gaiSIMliu_liang'),
        data: {
          selectedSim: this.selectedSim,
        },
      };
      this.updateNetworkFlowDialogVisible = true;
    },
    // 检测权限-撤销
    checkAuthCancel(row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      return !rows.some((item) => !this.checkBtnAuth(item, 'cancel'));
    },

    addSimSuccess() {
      this.formSearch.pageNum = 1;
      this.getTableList();
    },
    onSearch() {
      this.getTableList();
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
      this.yearChangeHandler();
    },
    getTableList() {
      const reqData = this.getTableListReqData();
      this.$getJSON(apis.simPage, reqData).then((res) => {
        this.simList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getTableListReqData() {
      const data = {
        ...this.formSearch,
      };
      const simEndTime = data.simEndTime;
      const lastUseTime = data.lastUseTime;
      delete data.lastUseTime;
      delete data.simEndTime;

      if (simEndTime && simEndTime.length) {
        data.simEndStartTime = simEndTime[0];
        data.simEndEndTime = simEndTime[1];
      }

      if (lastUseTime && lastUseTime.length) {
        data.lastUseStartTime = lastUseTime[0];
        data.lastUseEndTime = lastUseTime[1];
      }

      return data;
    },
    // 饼图
    drawPie() {
      if (!this.$refs.pie) {
        return;
      }

      if (this.pie) {
        this.pie.destroy();
        this.pie = null;
      }

      const allText = this.$t('Common.com_all');
      const { activated, unActivated, invalid, stop, unknown, allCount } = this.pieData;
      const data = [
        {
          type: this.$t('dms_sim.yi_ji_huoo', [activated]),
          percent: activated,
          color: 'rgb(61 204 166)',
        },
        {
          type: this.$t('dms_sim.wei_ji_huoo', [unActivated]),
          percent: unActivated,
          color: 'rgba(73, 157, 242, 1)',
        },
        {
          type: this.$t('dms_sim.yi_ting_yongo', [stop]),
          percent: stop,
          color: 'rgba(220, 224, 0, 1)',
        },
        {
          type: this.$t('dms_sim.yi_shi_xiaoo', [invalid]),
          percent: invalid,
          color: 'rgba(224, 224, 224, 1)',
        },
        {
          type: this.$t('dms_sim.wei_zhio', [unknown]),
          percent: unknown,
          color: '#FF5C5B',
        },
      ];
      const sum = allCount;
      const ds = new DataSet();
      const dv = ds.createView().source(data);

      const chart = new G2.Chart({
        container: this.$refs.pie,
        forceFit: true,
        height: 210,
        width: 300,
        padding: 'auto',
      });
      chart.source(dv);
      chart.tooltip(false);
      chart.legend({
        position: 'right-center',
        offsetX: -90,
        offsetY: 10,
        itemMarginBottom: 20,
      });
      chart.coord('theta', {
        radius: 0.75,
        innerRadius: 0.73,
      });
      chart
        .intervalStack()
        .position('percent')
        .color(
          'type',
          data.map((item) => item.color)
        )
        .opacity(1)
        .style({
          stroke: 'white',
          lineWidth: 1,
        })
        .label('percent', {
          offset: -18,
          textStyle: {
            fill: 'white',
            fontSize: 12,
            shadowBlur: 2,
            shadowColor: 'rgba(0, 0, 0, .45)',
          },
          rotate: 0,
          autoRotate: false,
          formatter: () => '',
        });
      // chart.guide();
      chart.guide().html({
        position: ['86%', '25%'],
        html: `<div class="pie-guide-html"><span class="title">${allText}</span><span class="value">${sum}</span></div>`,
      });
      chart.render();
      this.pie = chart;
    },
    // 获取饼图数据
    getPieData() {
      return this.$getJSON(apis.simDataTotalActivateCounts, {}).then((res) => res.data);
    },
    // 获取柱状图数据
    getBarData() {
      return this.$getJSON(`${apis.simDataMonthCounts}/${this.year.getFullYear()}`, {
        supplierName: this.formSearch.supplierName,
      }).then((res) => res.data);
    },
    // 柱状图
    drawBar() {
      if (!this.$refs.bar) {
        return;
      }

      if (this.bar) {
        this.bar.destroy();
        this.bar = null;
      }

      const numText = this.$t('dms_sim.shu_liang');
      const data = this.barData;
      const chart = new G2.Chart({
        container: this.$refs.bar,
        forceFit: true,
        height: 200,
        //  padding: 'auto',
        padding: [30, 0, 30, 0],
        // padding: [20, 20, 50, 20]
      });
      chart.tooltip({
        itemTpl: `<li data-index={index}><span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>${numText}<span class="g2-tooltip-value">{value}</span></li>`,
      });
      chart.axis('count', false);
      chart.axis('month', {
        // x轴文本配置
        label: {
          offsetY: 3,
          textStyle: {
            fill: '#6C757D',
          },
        },
        // x轴坐标轴线配置
        line: {
          // 坐标轴线颜色
          stroke: '#DEE2E6',
        },
        // x轴刻度线配置
        tickLine: {
          // 刻度线颜色
          stroke: '#DEE2E6',
          // 刻度线长度
          length: 4,
        },
      });
      chart.source(data);
      // chart.scale('month', {
      //   tickInterval: 20
      // });
      chart
        .interval()
        // 柱状图柱条宽度
        .size(30)
        .label('count')
        // 柱条颜色
        .color('#6DC2ED')
        .position('month*count');

      chart.render();
      this.bar = chart;
    },
    yearChangeHandler() {
      this.getBarData().then((data) => {
        const fixedData = this.fixBarData(data);
        this.barData = fixedData;
        this.updateBar();
      });
    },
    initCharts() {
      this.getPieData().then((data) => {
        this.pieData = data;
        this.$nextTick(() => {
          this.drawPie();
        });
      });

      this.getBarData().then((data) => {
        const fixedData = this.fixBarData(data);
        this.barData = fixedData;
        this.$nextTick(() => {
          this.drawBar();
        });
      });
    },
    // 更新柱状图
    updateBar() {
      if (this.bar) {
        this.bar.changeData(this.barData);
      } else {
        this.$nextTick(() => {
          this.drawBar();
        });
      }
    },
    // 格式化流量单位
    formatToMb(val) {
      if (val) {
        const ret = val / (1024 * 1024);
        return ret.toFixed(2);
      }
      return '';
    },
    exportTable() {
      const reqData = this.getTableListReqData();
      delete reqData.pageNum;
      delete reqData.pageSize;

      this.$exportFlie(apis.simExport, reqData);
    },
    // 激活
    onActive(row) {
      const tips = this.$t('dms_sim.qdyjhsxSIMk');
      this.statusMsg({
        subTitle: tips,
        message: this.$t('dms_sim.jhhkssf'),
        type: 'warning',
      }).then(() => {
        const { simId } = row;
        this.$postJSON(`${apis.simActive}/${simId}`, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    // 停用
    onStop(row) {
      const tips = this.$t('dms_sim.qdytysxSIMk');
      this.statusMsg({
        subTitle: tips,
        message: this.$t('dms_sim.tyhxgytzsf'),
        type: 'warning',
      }).then(() => {
        const { simId } = row;
        this.$postJSON(`${apis.simTerminated}/${simId}`, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    /**
     * 检测按钮是否显示
     * @param {object} row
     * @param {string} type 类型， active, stop, cancel
     * @return {boolean} ret
     */
    checkBtnAuth(row, type) {
      /** 新逻辑：根据供应商的卡类型和状态，进行判断
       * Hanxun CN ， Hanxun FR的卡
       * - 未激活，已停用，已失效的卡，支持：激活
       * - 已激活的卡，支持：停用
       *
       * Vodafoner的卡
       * - 未激活，已停用的卡，支持：激活
       * - 已激活的卡，支持：停用
       *
       * dms_sim_supplier_name supplierName
       */
      const dicMap = this.dicMap.sim_status;
      const supplierDicMap = this.dicMap.dms_sim_supplier_name;
      const supplierName = row.supplierName;
      if (supplierName) {
        // vdf   hx_cn  hx_fr
        // Hanxun CN ， Hanxun FR的卡
        const cnAndFr = [`${supplierDicMap.hx_cn}`, `${supplierDicMap.hx_fr}`];
        if (cnAndFr.includes(supplierName)) {
          const map = {
            active: [`${dicMap.un_activated}`, `${dicMap.terminated}`, `${dicMap.invalid}`],
            stop: [`${dicMap.activated}`],
          };
          const rule = map[type];
          if (rule) {
            return rule.includes(`${row.simState}`);
          }
        }

        if (`${supplierDicMap.hx_cn}` === supplierName) {
          const map = {
            active: [`${dicMap.un_activated}`, `${dicMap.terminated}`],
            stop: [`${dicMap.activated}`],
          };
          const rule = map[type];
          if (rule) {
            return rule.includes(`${row.simState}`);
          }
        }
      }

      /** 旧有逻辑 */
      // 激活  ： 未激活  已停用 已失效
      // 停用  ：已激活
      // 注销  ：已激活  已停用
      /**
       * SIM卡状态：sim_status
         0  未激活  un_activated
         10   已激活   activated
         20   已停用   terminated
         50   已失效   invalid
       *
       */

      const map = {
        active: [`${dicMap.un_activated}`, `${dicMap.terminated}`, `${dicMap.invalid}`],
        stop: [`${dicMap.activated}`],
        // cancel: [`${dicMap.activated}`, `${dicMap.terminated}`],
      };
      const rule = map[type];
      if (rule) {
        return rule.includes(`${row.simState}`);
      }
      return false;
    },
    updateSimStateSuccess() {
      this.getTableList();
    },
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView(null, () => {
      if (this.funcView.device_sim_list) {
        this.$nextTick(() => {
          this.initCharts();
        });
      }

      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getDicMap('sim_status,dms_sim_supplier_name', () => {
      this.getTableList();
    });
  },
};
</script>

<style lang="scss">
.page-sim {
  padding: 16px;
  padding-bottom: 0;
  display: flex;
  height: 100%;
  flex-direction: column;

  .chart-container {
    height: 280px;
    display: flex;
    justify-content: space-between;

    .chart-title {
      position: absolute;
      z-index: 1000;
      color: #495057;
      font-size: 12px;
      line-height: 28px;
      font-weight: bold;
      top: 16px;
      left: 24px;
    }

    .pie {
      height: 280px;
      width: 400px;
      background: #fff;
      position: relative;

      .chart-pie {
        overflow: hidden;
        position: relative;
        left: -68px;
        top: 48px;
      }
    }

    .bar {
      position: relative;
      flex: 1;
      background: #fff;
      height: 100%;
      margin-left: 16px;
      .chart-bar {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 62px;
        position: relative;
        height: 200px;
      }
      .supplier-search {
        position: absolute;
        right: 148px;
        top: 16px;
        width: 180px !important;
      }
      .year-picker {
        position: absolute;
        right: 24px;
        top: 16px;
        width: 100px;
      }
    }
  }

  .list-container {
    background: #fff;
    margin-top: 16px;
    padding: 0 16px;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    flex: 1;
  }

  .el-date-editor {
    width: 100%;
  }

  .empty-bottom {
    width: 100%;
    height: 16px;
  }
}
</style>
